import { render } from "./IconElectraChildSeat.vue?vue&type=template&id=46530a02"
import script from "./IconElectraChildSeat.vue?vue&type=script&lang=js"
export * from "./IconElectraChildSeat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__